import React, { useState } from 'react';
import { Field } from 'redux-form';
import { renderNumber } from "Utils/renderField/renderField"; 
import SettingToggle from "../../../components/Utils/Ayuda/SettingToggle";
import ModalVideo from "../../../components/Utils/Ayuda/ModalVideo";

import "./secciones.css";

const PropiedadesProductoSection = (props) => {
    const { 
        isModal,
        onNext, 
        onPrevious, 
        canGoNext, 
        canGoPrevious, 
        inventariableValue, 
        alertaValue,
        readOnlyMode = false, 
    } = props;


    //Soporte de videos
    const [videos, setVideos] = useState(null);
    
    const openVideoModal = function(videos){
    setVideos(videos);
    };
    
    const closeVideoModal = function(){
    setVideos(null);
    };
    
    return (
        <div className={isModal ? "" : "section-panel"}>
            {!isModal && (
                <div className="section-header">
                    <h4>Propiedades de producto</h4>
                    {!readOnlyMode && (
                    <div className="section-actions">
                        <button type="button" className="btn btn-secondary" onClick={onPrevious} disabled={!canGoPrevious}>Regresar</button>
                        <button type="button" className="btn btn-primary" onClick={onNext} disabled={!canGoNext}>Siguiente</button>
                    </div>
                    )}
                </div>
            )}
            
            <div className={readOnlyMode ? "read-only-wrapper" : ""}>
            <div className="row row-fields">
                {/* --- LÓGICA PARA MODAL (Fracciones) --- */}
                {isModal && (
                    <div className="col-md-6 mb-4">
                        <label htmlFor="vendible">Vendible</label>
                        <br />
                        <label className="switch">
                            <Field name="vendible" component="input" type="checkbox" />
                            <span className="slider round"></span>
                        </label>
                    </div>
                )}
                {isModal && (
                    <div className="col-md-6 mb-4">
                        <label htmlFor="alertar">Alertar</label>
                        <br />
                        <label className="switch">
                            <Field name="alertar" component="input" type="checkbox" />
                            <span className="slider round"></span>
                        </label>
                    </div>
                )}

                <div className="w-100 text-muted small mb-2">
                    Define cómo se gestionará este producto dentro del sistema. Aquí puedes indicar si estará disponible para la venta, si llevará control de inventario y si deseas recibir alertas cuando las existencias sean bajas.
                </div>

                {/* --- LÓGICA PARA SECCIÓN (Producto Principal) --- */}
                {!isModal && (
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="vendible"
                            title="Vendible"
                            description="Aparecerá en el punto de venta"
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272110/Vendible_kkanef.mp4"]}
                            onOpenModal={openVideoModal}
                            disabled={readOnlyMode}
                        />
                    </div>
                )}
                {!isModal && (
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="inventariable"
                            title="Inventariable"
                            description="El producto llevara registro de cuantas unidades tiene disponible"
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272241/Inventareable_tpt9td.mp4"]}
                            onOpenModal={openVideoModal}
                            disabled={readOnlyMode}
                        />
                    </div>
                )}
                {!isModal && Boolean(inventariableValue) && (
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="alertar"
                            title="Alerta"
                            description="Cuando el producto tiene pocas existencias, el sistema mostrará una alerta..."
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272326/Alerta_nz7gpn.mp4"]}
                            onOpenModal={openVideoModal}
                            disabled={readOnlyMode}
                        />
                    </div>
                )}

                {/* --- CAMPO COMÚN: MÍNIMO EXISTENCIAS --- */}
                {(Boolean(alertaValue)) && (
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <label htmlFor="minimo_existencias">Mínimo cantidad existencia *</label>
                        <Field
                            name="minimo_existencias"
                            component={renderNumber}
                            type="number"
                            className="form-control"
                            readOnly={readOnlyMode}
                        />
                    </div>
                )}
            </div>
            </div>
            {/*--- MODAL DE EJEMPLOS --- */}
            {videos && (
                <ModalVideo
                    videos={videos}
                    onClose={closeVideoModal}
                />
            )}
        </div>
    );
};

export default PropiedadesProductoSection;